import { RecipeIngredientFormValue } from '../../interfaces/RecipeFormValues';

type IngredientIdentity = Pick<
  RecipeIngredientFormValue,
  'name' | 'my_net_diary_bean_id'
>;

/**
 * Nutritionix items match by bean id, own foods by case-insensitive name - a loaded ingredient
 * carries no food id, so two own foods with the same name cannot both be added.
 */
export const isSameIngredient = (
  a: IngredientIdentity,
  b: IngredientIdentity,
): boolean => {
  if (a.my_net_diary_bean_id != null || b.my_net_diary_bean_id != null) {
    return a.my_net_diary_bean_id === b.my_net_diary_bean_id;
  }

  return a.name.toLowerCase() === b.name.toLowerCase();
};
